<ng-container *ngIf="!activeCallout; else showForm">
    Click on the map to add a new callout box, or click on an existing callout to edit it.
</ng-container>
<ng-template #showForm>
    <form>
        <div class="setting">
            <label for="box-alignment">Box Alignment</label>
            <select id="box-alignment" class="select-full modifier-class" name="boxAlignment"
                    [(ngModel)]="activeCallout.boxAlignment" (change)="updateGraphic(activeCallout)">
                <option *ngFor="let option of boxAlignmentOptions" [value]="option">{{ option }}</option>
            </select>
        </div>
        <div class="setting">
            <label>Box Size</label>
            <span class="input-group">
                <input id="box-width" type="number" [min]="activeCallout.boxWidthMin" [max]="activeCallout.boxWidthMax" name="boxWidth" [(ngModel)]="activeCallout.boxWidth" (change)="updateGraphic(activeCallout)">
                <span class="separator">x</span>
                <input id="box-height" type="number" [min]="activeCallout.boxHeightMin" [max]="activeCallout.boxHeightMax" name="boxHeight" [(ngModel)]="activeCallout.boxHeight" (change)="updateGraphic(activeCallout)">
            </span>
        </div>
        <div class="setting">
            <label for="layer-name">Tail Size</label>
            <input id="tail-size" type="number" [min]="activeCallout.tailSizeMin" [max]="activeCallout.tailSizeMax" name="tailSize" [(ngModel)]="activeCallout.tailSize" (change)="updateGraphic(activeCallout)"
                   placeholder="Length of callout box tail">
        </div>
        <div class="setting">
            <label for="fillColor" (click)="fillColorPicker.showColorPicker = true;">Fill Color</label>
            <mc-color-picker-ng
                #fillColorPicker
                [(color)]="activeCallout.symbolProperties.color"
                (colorChange)="updateGraphic(activeCallout)"
                [siblingColorPickers]="[outlineColorPicker, textColorPicker]"></mc-color-picker-ng>
        </div>
        <div class="setting">
            <label for="outlineColor" (click)="outlineColorPicker.showColorPicker = true;">Outline Color</label>
            <mc-color-picker-ng
                #outlineColorPicker
                [(color)]="activeCallout.symbolProperties.outline.color"
                (colorChange)="updateGraphic(activeCallout)"
                [siblingColorPickers]="[fillColorPicker, textColorPicker]"></mc-color-picker-ng>
        </div>
        <div class="setting">
            <label for="outline-width">Outline Width</label>
            <input id="outline-width" type="number" min="outlineMin" max="outlineMax" name="outlineWidth" [(ngModel)]="activeCallout.symbolProperties.outline.width" (change)="updateGraphic(activeCallout)">
        </div>
        <div class="setting">
            <label for="textColor" (click)="textColorPicker.showColorPicker = true;">Text Color</label>
            <mc-color-picker-ng
                #textColorPicker
                [(color)]="activeCallout.textProperties.color"
                (colorChange)="updateGraphic(activeCallout)"
                [siblingColorPickers]="[fillColorPicker, outlineColorPicker]"></mc-color-picker-ng>
        </div>
        <div class="setting">
            <label for="text-size">Text Size</label>
            <input id="text-size" type="number" min="textSizeMin" max="textSizeMax" name="textSize" [(ngModel)]="activeCallout.textProperties.font.size" (change)="updateGraphic(activeCallout)">
        </div>
        <div class="setting">
            <label for="text">Text</label>
            <textarea id="text" name="text" [(ngModel)]="activeCallout.textProperties.text" (change)="updateGraphic(activeCallout)"
                      placeholder="Enter text here" rows="4"></textarea>
        </div>
        <div class="setting" *ngIf="showImageUpload">
            <label for="image">Image</label>
            <div style="margin-left:14%; min-height:100px; max-height:415px; width:100%; border: 1px solid gray;">
                <img id="cbImage" [src]="cbImageSource ? cbImageSource : ''" alt="Add an image">
                <div style="position:absolute; bottom:10px; width:74%;">
                    <label for="fileUpload" class="custom_fileUpload">
                        <i class="fa fa-cloud-upload"></i>Upload Image
                    </label>
                    <input id="fileUpload" type="file" accept="image/*" (change)="onFileSelected($event)">

                    <label for="rmImgBtn" *ngIf="imageOn" class="custom_fileUpload" style="float:right;">
                        <i class="fa fa-trash-o"></i>Delete
                    </label>
                    <button id="rmImgBtn" type="button" (click)="removeImage()"></button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
